"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskViews = void 0;
const ViewFieldKey_1 = __importDefault(require("@opsbase/lib-data-viewfield/ViewFieldKey"));
const ViewFieldRegistry_1 = __importDefault(require("@opsbase/lib-data-viewfield/ViewFieldRegistry"));
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const App_1 = __importDefault(require("@opsbase/lib-system/App"));
const View_1 = __importDefault(require("../View"));
exports.TaskViews = [
    new View_1.default({
        apps: [App_1.default.ADMINBASE],
        id: DataType_1.default.TASK,
        title: () => lib_i18n_1.default.t('tasks'),
        type: DataType_1.default.TASK,
        filters: [],
        groupBys: [],
        sortBy: ViewFieldKey_1.default.CREATEDDATE,
        sortByDesc: true,
        autoRefresh: 30,
        fields: [
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.TITLE],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.TASK_TYPE],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.TASK_STATUS],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.CREATEDDATE],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.TASK_STARTED],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.TASK_COMPLETED],
            ViewFieldRegistry_1.default[ViewFieldKey_1.default.TASK_DURATION],
        ],
    }),
];
exports.default = exports.TaskViews;
